module.exports = __webpack_public_path__ + "img/9.1e245ebf.svg";